function initMarketplaceGallery(gallery) {
  if (!gallery || gallery.dataset.galleryReady === '1') {
    return;
  }

  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  if (!slides.length) {
    return;
  }

  gallery.dataset.galleryReady = '1';

  if (slides.length === 1) {
    slides[0].classList.add('is-active');
    return;
  }

  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const prevBtn = gallery.querySelector('[data-gallery-prev]');
  const nextBtn = gallery.querySelector('[data-gallery-next]');
  const viewport = gallery.querySelector('[data-gallery-viewport]');
  let index = slides.findIndex((slide) => slide.classList.contains('is-active'));

  if (index < 0) {
    index = 0;
  }

  function goTo(target) {
    index = (target + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === index);
    });

    thumbs.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle('is-active', thumbIndex === index);
    });
  }

  prevBtn?.addEventListener('click', () => goTo(index - 1));
  nextBtn?.addEventListener('click', () => goTo(index + 1));

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const target = Number(thumb.dataset.galleryIndex);
      if (!Number.isNaN(target)) {
        goTo(target);
      }
    });
  });

  let touchStartX = 0;

  viewport?.addEventListener('touchstart', (event) => {
    touchStartX = event.changedTouches[0].clientX;
  }, { passive: true });

  viewport?.addEventListener('touchend', (event) => {
    const diff = touchStartX - event.changedTouches[0].clientX;
    if (Math.abs(diff) < 40) {
      return;
    }

    goTo(diff > 0 ? index + 1 : index - 1);
  }, { passive: true });

  goTo(index);
}

function bootMarketplaceGalleries(root = document) {
  root.querySelectorAll('[data-marketplace-gallery]').forEach(initMarketplaceGallery);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bootMarketplaceGalleries(), { once: true });
} else {
  bootMarketplaceGalleries();
}

document.addEventListener('livewire:navigated', () => {
  requestAnimationFrame(() => bootMarketplaceGalleries());
});

// ── Keep the chat thread scrolled to the newest message ───────────────────────
function scrollChatToBottom() {
  document.querySelectorAll('.mp-chat__thread').forEach((el) => {
    el.scrollTop = el.scrollHeight;
  });
}

document.addEventListener('livewire:init', () => {
  window.Livewire?.hook?.('commit', ({ succeed }) => {
    succeed(() => requestAnimationFrame(scrollChatToBottom));
  });
});
document.addEventListener('livewire:navigated', () => requestAnimationFrame(scrollChatToBottom));
